// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Invoice Templates Styles
 * Modern, responsive styles for invoice templates management
 */

.invoice-templates {
  padding: 24px;
  background:
    radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.05) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.05) 0%, transparent 50%),
    linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
}

/* Header */
.templates-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  padding: 24px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.1),
    0 4px 16px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.header-content h2 {
  color: #2d3748;
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 8px 0;
  line-height: 1.2;
}

.header-content p {
  color: #4a5568;
  font-size: 1rem;
  margin: 0;
  line-height: 1.5;
}

.header-actions {
  display: flex;
  gap: 12px;
}

/* Filters */
.templates-filters {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.filters-content {
  display: flex;
  gap: 20px;
  align-items: end;
  flex-wrap: wrap;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 150px;
}

.filter-label {
  color: #4a5568;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.filter-select,
.filter-input {
  padding: 12px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: white;
  color: #2d3748;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.filter-select:focus,
.filter-input:focus {
  outline: none;
  border-color: #0D3B66;
  box-shadow: 0 0 0 3px rgba(13, 59, 102, 0.1);
}

.filters-actions {
  display: flex;
  gap: 12px;
  align-items: end;
}

/* Bulk Actions */
.bulk-actions {
  background: rgba(102, 126, 234, 0.1);
  border: 1px solid rgba(102, 126, 234, 0.2);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 24px;
}

.bulk-actions-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.selected-count {
  color: #2d3748;
  font-weight: 600;
  font-size: 0.9rem;
}

.bulk-controls {
  display: flex;
  gap: 12px;
  align-items: center;
}

/* Templates Content */
.templates-content {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  padding: 24px;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

/* Templates Grid */
.templates-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
}

/* Templates Table */
.templates-table {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  overflow: hidden;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.templates-table table {
  width: 100%;
  border-collapse: collapse;
}

.templates-table th {
  background: rgba(102, 126, 234, 0.1);
  color: #2d3748;
  font-weight: 600;
  padding: 16px;
  text-align: left;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.templates-table td {
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  color: #4a5568;
}

.templates-table tr:hover {
  background: rgba(102, 126, 234, 0.05);
}

/* Status Badge */
.status-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-badge.active {
  background: rgba(56, 161, 105, 0.1);
  color: #38a169;
}

.status-badge.inactive {
  background: rgba(113, 128, 150, 0.1);
  color: #718096;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.1),
    0 4px 16px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.empty-icon {
  font-size: 4rem;
  margin-bottom: 20px;
  opacity: 0.6;
}

.empty-state h3 {
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 12px 0;
}

.empty-state p {
  color: #4a5568;
  font-size: 1rem;
  margin: 0;
  line-height: 1.5;
}

/* Loading */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

/* Buttons */
.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
  color: white;
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-outline {
  background: transparent;
  color: #0D3B66;
  border: 1px solid #0D3B66;
}

.btn-outline:hover:not(:disabled) {
  background: #0D3B66;
  color: white;
}

.btn-icon {
  font-size: 1rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .invoice-templates {
    padding: 16px;
  }

  .templates-header {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }

  .header-actions {
    width: 100%;
    justify-content: center;
  }

  .filters-content {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-group {
    min-width: auto;
  }

  .bulk-actions-content {
    flex-direction: column;
    align-items: stretch;
  }

  .bulk-controls {
    flex-direction: column;
    gap: 8px;
  }

  .templates-table {
    overflow-x: auto;
  }

  .templates-table table {
    min-width: 600px;
  }

  .templates-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .invoice-templates {
    padding: 12px;
  }

  .templates-header {
    padding: 16px;
  }

  .header-content h2 {
    font-size: 1.5rem;
  }

  .templates-grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/invoices/InvoiceTemplates.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,aAAa;EACb;;;qDAGmD;EACnD,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB;;kCAEgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB;;iCAE+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb;;iCAE+B;EAC/B,0CAA0C;AAC5C;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB;;iCAE+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB;;kCAEgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/**\n * Invoice Templates Styles\n * Modern, responsive styles for invoice templates management\n */\n\n.invoice-templates {\n  padding: 24px;\n  background:\n    radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.05) 0%, transparent 50%),\n    radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.05) 0%, transparent 50%),\n    linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  min-height: 100vh;\n}\n\n/* Header */\n.templates-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n  padding: 24px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 16px;\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.1),\n    0 4px 16px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.header-content h2 {\n  color: #2d3748;\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 0 0 8px 0;\n  line-height: 1.2;\n}\n\n.header-content p {\n  color: #4a5568;\n  font-size: 1rem;\n  margin: 0;\n  line-height: 1.5;\n}\n\n.header-actions {\n  display: flex;\n  gap: 12px;\n}\n\n/* Filters */\n.templates-filters {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 24px;\n  box-shadow:\n    0 4px 16px rgba(0, 0, 0, 0.1),\n    0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.filters-content {\n  display: flex;\n  gap: 20px;\n  align-items: end;\n  flex-wrap: wrap;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 150px;\n}\n\n.filter-label {\n  color: #4a5568;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.filter-select,\n.filter-input {\n  padding: 12px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: white;\n  color: #2d3748;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n}\n\n.filter-select:focus,\n.filter-input:focus {\n  outline: none;\n  border-color: #0D3B66;\n  box-shadow: 0 0 0 3px rgba(13, 59, 102, 0.1);\n}\n\n.filters-actions {\n  display: flex;\n  gap: 12px;\n  align-items: end;\n}\n\n/* Bulk Actions */\n.bulk-actions {\n  background: rgba(102, 126, 234, 0.1);\n  border: 1px solid rgba(102, 126, 234, 0.2);\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 24px;\n}\n\n.bulk-actions-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n}\n\n.selected-count {\n  color: #2d3748;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.bulk-controls {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n/* Templates Content */\n.templates-content {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow:\n    0 4px 16px rgba(0, 0, 0, 0.1),\n    0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n/* Templates Grid */\n.templates-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 20px;\n}\n\n/* Templates Table */\n.templates-table {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow:\n    0 4px 16px rgba(0, 0, 0, 0.1),\n    0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.templates-table table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.templates-table th {\n  background: rgba(102, 126, 234, 0.1);\n  color: #2d3748;\n  font-weight: 600;\n  padding: 16px;\n  text-align: left;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.templates-table td {\n  padding: 16px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  color: #4a5568;\n}\n\n.templates-table tr:hover {\n  background: rgba(102, 126, 234, 0.05);\n}\n\n/* Status Badge */\n.status-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-badge.active {\n  background: rgba(56, 161, 105, 0.1);\n  color: #38a169;\n}\n\n.status-badge.inactive {\n  background: rgba(113, 128, 150, 0.1);\n  color: #718096;\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 16px;\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.1),\n    0 4px 16px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.empty-icon {\n  font-size: 4rem;\n  margin-bottom: 20px;\n  opacity: 0.6;\n}\n\n.empty-state h3 {\n  color: #2d3748;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0 0 12px 0;\n}\n\n.empty-state p {\n  color: #4a5568;\n  font-size: 1rem;\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* Loading */\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n}\n\n/* Buttons */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.btn-outline {\n  background: transparent;\n  color: #0D3B66;\n  border: 1px solid #0D3B66;\n}\n\n.btn-outline:hover:not(:disabled) {\n  background: #0D3B66;\n  color: white;\n}\n\n.btn-icon {\n  font-size: 1rem;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .invoice-templates {\n    padding: 16px;\n  }\n\n  .templates-header {\n    flex-direction: column;\n    gap: 16px;\n    text-align: center;\n  }\n\n  .header-actions {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .filters-content {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .filter-group {\n    min-width: auto;\n  }\n\n  .bulk-actions-content {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .bulk-controls {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .templates-table {\n    overflow-x: auto;\n  }\n\n  .templates-table table {\n    min-width: 600px;\n  }\n\n  .templates-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .invoice-templates {\n    padding: 12px;\n  }\n\n  .templates-header {\n    padding: 16px;\n  }\n\n  .header-content h2 {\n    font-size: 1.5rem;\n  }\n\n  .templates-grid {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
